/* istanbul ignore file: Directive */
'use strict';


/**
 * Check if an imei number is valid.
 */
customerZone.directive('validateImei', ['utils', function (utils) {
    return {
        require: 'ngModel',
        link: function (scope, elem, attrs, ctrl) {
            ctrl.$validators.imei = function(modelValue, viewValue){
                if (ctrl.$isEmpty(modelValue)) return true;
                if (!(/^\d{17}$|^\d{15}$/.test(viewValue))) return false;
                else {
                    var valid =  utils.checkImei(viewValue);
                    return valid.valid;
                }
            };
        }
    };
}]);
